import * as React from 'react';
import './ScrollButton.scss';
import i18n from 'src/translation/i18n';
import feedback from 'src/assets/feedbackIcon';
import scrollTop from 'src/assets/scrollTopIcon';

class ScrollButton extends React.Component {
  public render() {
    return (
      <div className="scrolltop">
        <img
          src={scrollTop}
          alt="scrollTop"
          className="rp-scroll-icon"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        />

        <span className="arrow-up glyphicon glyphicon-chevron-up" />
        <a id="feedback-trigger" className="feedback-trigger">
          <img src={feedback} alt="" />
          <span>{i18n.t('common.feedback')}</span>
        </a>
      </div>
    );
  }
}

export default ScrollButton;
